/** @format */

import { Alert, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../app/hooks";
import CircularLoader from "../../../common/loaders/circularLoader";
import { selectApplicant } from "../../applicant/ApplicantSlice";
import { ApplicantViewDto, DocumentsViewDto } from "../../applicant/Models";
import ExtensionChecker from "../../applicant/profile/components/documents/ExtensionChecker";
import AddAdditionalDocuments from "./AddAdditionalDocuments";

export default function ViewDocuments() {
  const selectApplicantData = useAppSelector(selectApplicant);
  const [data, setData] = useState<ApplicantViewDto>();

  useEffect(() => {
    if (selectApplicantData.applicantState.applicant) {
      setData(selectApplicantData.applicantState.applicant);
    }
  }, [selectApplicantData.applicantState.applicant]);

  return (
    <>
      <CircularLoader status={selectApplicantData.applicantState.status} />
      {data && data.documents.length < 1 && (
        <>
          <Alert severity="info" variant="standard" color="info">
            There are no documents to display
          </Alert>
        </>
      )}
      {data && data.documents && (
        <Grid container spacing={1}>
          {data.documents.map((document: DocumentsViewDto, key: React.Key) => {
            return (
              <Grid item xs={2.3} key={key}>
                <ExtensionChecker document={document} />
              </Grid>
            );
          })}

          <Grid item xs={12}>
            <AddAdditionalDocuments applicantId={data.applicationId} />
          </Grid>
        </Grid>
      )}
    </>
  );
}
